import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getNhDealApplicationId } from "features/authSlice";
import { getLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { useGetloanOfficerQuery } from "pages/application/applicationService";

export const useLoanOfficer = () => {
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const loanOfficerFromCache = useSelector(getLoanOfficerDetail);

  const {
    data: loanOfficerFromApi,
    isLoading,
    isSuccess,
    error,
  } = useGetloanOfficerQuery(nhDealApplicationId, {
    skip: !nhDealApplicationId || !!loanOfficerFromCache,
  });

  const loanOfficer = useMemo(() => {
    return loanOfficerFromCache ?? loanOfficerFromApi;
  }, [loanOfficerFromCache, loanOfficerFromApi]);

  return {
    loanOfficer,
    isLoading,
    isSuccess,
    error,
    hasLoanOfficer: !!loanOfficer
  };
};
